(function() {
	'use strict';

	angular.module('widgets.initiative')
	.service('leanProjectGeneralSavingsService', leanProjectGeneralSavingsService);

	function leanProjectGeneralSavingsService($http, URLS) {
		return {
			getLeanProjectSummary: getLeanProjectSummary,
			getTopLeanProjectsByViewType: getTopLeanProjectsByViewType
		};

		function getLeanProjectSummary(filterService, viewBy, displayType) {
			var url = buildUrl('/SummaryOfProjects', displayType, viewBy, filterService);
			return $http.get(url)
				.then(getLeanProjectSummaryComplete)
				.catch(getLeanProjectSummaryFailed);

			function getLeanProjectSummaryComplete(response) {
				return response.data;
			}
			function getLeanProjectSummaryFailed(error) {
				return error;
			}
		}

		function getTopLeanProjectsByViewType(filterService, viewBy, displayType) {
			var url = buildUrl('/TopLeanProjectByViewType', displayType, viewBy, filterService);
			return $http.get(url)
				.then(getLeanProjectSummaryComplete)
				.catch(getLeanProjectSummaryFailed);

			function getLeanProjectSummaryComplete(response) {
				return response.data;
			}
			function getLeanProjectSummaryFailed(error) {
				return error;
			}
		}

		function buildUrl(path, displayType, groupBy, filterService) {
			var factories = filterService.getFactoryList();
			var url = URLS.host + URLS.prefix + factories + path;
			url += '?type=' + displayType;
			url += '&groupBy=' + groupBy;
			return filterService.addFilterQueryParams(url);
		}
	}
})();